<template>
  <div>

      <h5>アクティビティ</h5>
      <hr>

      <div class="py-3 contents">
        <p>コメント未返信 {{ not_replay_comment }}件 <a v-if="not_replay_comment>0" class="ml-3 btn btn-info" href="javascript:void(0);" @click="jumpComment">確認する</a></p>
        <p>メッセージ未返信 {{ not_replay_message }}件 <a v-if="not_replay_message>0" class="ml-3 btn btn-info" href="javascript:void(0);" @click="jumpMessage">確認する</a></p>
      <div>

  </div>
</template>

<script>
export default {
  props: { 
    user: Object
  },
  data() {
    return {
      not_replay_message: 0,
      not_replay_comment: 0,
    }
  },
	methods: {
	  jumpMessage: function(){
      // location.href = '/mypage?page=5';
      this.$router.push({path: '/mypage', query: {page: 5}});
	  },
    jumpComment: function(){
      // location.href = '/mypage?page=5';
      this.$router.push({path: '/mypage', query: {page: 8}});
	  },
	  async get_dashboard() {
		  this.$store.dispatch('user/get_dashboard', {}).then(res => {
		    let ret = res.data;
		    console.log(ret);
		    this.not_replay_message = ret['not_replay_message'];
		    this.not_replay_comment = ret['not_replay_comment'];
		  }, error => {
		    console.log('error発生');
		    console.log(error);
		    this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
		    });
  	  });
	  },
  },
  created() {
    this.get_dashboard();
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/buyer/main.vue